import { Injectable } from '@angular/core';
import {Observable, Subject} from "rxjs";

@Injectable()
export class ConnectService {
  private subject = new Subject<number[]>();

  sendLeadIds(ids: number[]) {
    this.subject.next(ids);
  }

  getLeadIds(): Observable<number[]> {
    return this.subject.asObservable();
  }
}
